// frontend/src/components/HomePage/index.js
import HomePage from './HomePage';

export default HomePage;
